import "./handle-load-error";

import { init } from "@sentry/capacitor";
import { init as reactInit, reactErrorHandler } from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app";

init(
  {
    dsn: "https://682e1662df2370b51adcaf062e0d7202@o4509958651248640.ingest.us.sentry.io/4509958654787584",
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
  },
  reactInit,
);

createRoot(document.getElementById("root") as HTMLElement, {
  onUncaughtError: reactErrorHandler(),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
